exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game[data-v-4716111a] {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: calc(100vh - 400px);\n}\n.game > *[data-v-4716111a] {\n  margin-bottom: 8px;\n}\n.info[data-v-4716111a] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.info .status[data-v-4716111a] {\n  flex-grow: 1;\n}\n.info span.code[data-v-4716111a] {\n  font-size: 1.4rem;\n  font-weight: bold;\n  font-family: monospace;\n}", ""]);

// exports
